module.exports = __webpack_public_path__ + "img/40_38_049_450.bb884ecb.jpg";